import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import Axios from 'axios';
import { Input, DatePicker, Row, Col, Select, Card, notification, Space, Spin, Button, message as Message, Upload, Tabs } from 'antd';
import AntdInput from '../../Components/AntdInput';
import { UploadOutlined, CaretDownOutlined } from '@ant-design/icons'

import dayjs from 'dayjs';
import { get_mcm_url, get_v10_url } from '../../utils/commonUtilities';
import Cookies from 'js-cookie';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import CreateBookingIcon from '../../Assets/images/sidebar-icons/patient-details.svg'
import GlobalLoader from '../../Components/GlobalLoader';


function CreateBooking(props) {

    const dateFormat = 'DD-MMM-YYYY';
    const [insuranceList, setInsuranceList] = useState([])
    const [reportImages, setReportImages] = useState([])
    const [insuranceImages, setInsuranceImages] = useState([])
    const [insurancePdf, setInsurancePdf] = useState("")
    const [reportPdfs, setReportPdfs] = useState([])
    const [loading, setLoading] = useState(false)
    const [message, set_message] = useState(false)
    const [tabIndex, setTabIndex] = useState('1')
    const [userDetails, setUserDetails] = useState({
        mobileNumber: "",
        name: "",
        address: "",
        emailId: "",
        gender: "",
        dob: "",
        age: "",
        hospitalCenter: "",
        treatmentDetails: "",
        treatment: "",
        alternateNumber: "",
        documents: []
    })
    const [newUserDoc, setNewUserDoc] = useState({
        type: null,
        file: '',
        url: ''
    })
    const [userDocs, setUserDocs] = useState([])
    const [uploadedFile, setUploadedFile] = useState(null)
    const [firstUploadFile, setFirstUploadFile] = useState(null)
    const [firstDoc, setFirstDoc] = useState({
        type: 'PRE AUTHORIZATION REQUEST FORM',
        file: '',
        url: ''
    })

    const [policyDetails, setPolicyDetails] = useState({
        policyNumner: "",
        insurancePartner: "",
        serviceTPA: "",
        ipNumber: "",
        cardNumber: "",
        doa: "",
        costEstimation: "",
        dod: "",
        roomRent: "",
        iCURent: "",
        nursingCharges: "",
        superSpecialityCharges: "",
        cvc: "",
        soa: "",
        others: "",
        specifiedRoomCategory: "",
        roomCategory: "",
        remarks: "",
        discount: "",
        policyType: "",
        corporatePolicy: "",
        retailPolicy: "",
        consultingDoctor: "",
        certificateNumber: "",
        doctorContactNumber: "",
        consultCharges : "",
        treatingSurgeon: "",
        otCharges: "",
        pharmacyCharges: "",
        anestheticFees: "",
        investigation: "",
        others: "",
        totalRoomRent: "",
    })
    const [disableSaveBtn, setDisableSaveBtn] = useState(false)

    useEffect(() => {
        props.setActiveSideKey('2')
    }, [])

    const history = useHistory()

    const getInsuranceList = async () => {
        try {
            setLoading(true)
            const insuranceList = await Axios.get(`${get_mcm_url()}/insurance`)
            let iArray = [ {
                name: "Cash",
                value: "Cash"
            }]
            if(insuranceList.data.success)
                insuranceList.data.data.map((insurance) => {
                    if(insurance.insurancePartner !== "Test Insurance") {
                        iArray.push({
                            name: insurance.insurancePartner,
                            value: insurance.insurancePartner
                        })
                    }
                })
            setInsuranceList(iArray)
            setLoading(false)

        } catch (error) {
            console.error(error)
            setLoading(false)
        }
    }

    useEffect(() => {
        getInsuranceList()
        return () => {
            setInsuranceList(null)
        }
    }, [])

    useEffect(() => {
        if(policyDetails.policyType === "Retail Policy") {
            setPolicyDetails({
                ...policyDetails,
                corporatePolicy: ""
            })
        }
        if(policyDetails.policyType === "Corporate Policy") {
            setPolicyDetails({
                ...policyDetails,
                retailPolicy: ""
            })
        }
    }, [policyDetails.policyType])

    useEffect(() => {
        if(policyDetails.insurancePartner === 'Cash') {
            setPolicyDetails({
                ...policyDetails,
                policyNumner: '',
                policyType: '',
                corporatePolicy: ''
            })
        }
    }, [policyDetails.insurancePartner])

    const uploadDocs = async () => {
        // e.preventDefault()
        // setLoading(true)
        // const formData = new FormData()
        // for (var i = 0; i < e.target.files.length; i++) {
        //     formData.append('file', e.target.files[i])
        // }
        // for (var i = 0; i < userDocs.length; i++) {
        //     formData.append('file', userDocs[i].file)
        // }
        // props.upload_patient_report({
        //     files: formData,
        //     type: "REPORT"
        // })
    }

    const uploadInsuranceDoc = async (e) => {
        e.preventDefault()
        setLoading(true)
        const formData = new FormData()
        formData.append('file', e.target.files[0])
        props.upload_patient_insurance({
            files: formData,
            type: "POLICY"
        })
    }

    const uploadReportImages = async (e) => {
        e.preventDefault()
        setLoading(true)
        const formData = new FormData()

        for (var i = 0; i < e.target.files.length; i++) {
            formData.append('file', e.target.files[i])
        }
        props.upload_patient_report({
            files: formData,
            type: "IMAGE"
        })
    }

    const uploadInsuranceImages = async (e) => {
        e.preventDefault()
        setLoading(true)
        const formData = new FormData()

        for (var i = 0; i < e.target.files.length; i++) {
            formData.append('file', e.target.files[i])
        }
        props.upload_patient_insurance({
            files: formData,
            type: "CARD"
        })
    }

    useEffect(() => {
        if(userDetails.treatment === "Medical Management") {
            setPolicyDetails({
                ...policyDetails,
                otCharges: '',
                anestheticFees: '',
                soa: '',
            })
        }
    }, [userDetails.treatment])

    useEffect(()=>{
        if(!!props.upload_patient_report_ret){
                if(props.upload_patient_report_ret.success){
                if(props.upload_patient_report_ret.data.reportType === "IMAGE") {
                    let imageURLS = []
                    props.upload_patient_report_ret.data.reports.map((report) => {
                        imageURLS.push(report)
                    })
                    setReportImages(imageURLS)
                } else {
                    let pdfURLS = []
                    props.upload_patient_report_ret.data.reports.map((report) => {
                        pdfURLS.push(report)
                    })
                    setReportPdfs(pdfURLS)  
                }
            } else {
                notification["error"]({
                    message: "Error",
                    descriptioncess:"Upload Failed"
                });
            }
        }
        setLoading(false)
        props.upload_patient_report_loading()

    },[props.upload_patient_report_ret])

    useEffect(()=>{
        if(!!props.upload_patient_insurance_ret){
                if(props.upload_patient_insurance_ret.success){
                if(props.upload_patient_insurance_ret.data.reportType === "INSURANCE_CARD") {
                    let imageURLS = []
                    props.upload_patient_insurance_ret.data.reports.map((report) => {
                        imageURLS.push(report.url)
                    })
                    setInsuranceImages(imageURLS)
                } else {
                    setInsurancePdf(props.upload_patient_insurance_ret.data.reports.url)  
                }
            } else {
                notification["error"]({
                    message: "Error",
                    descriptioncess:"Upload Failed"
                });
            }
        }
        setLoading(false)
        props.upload_patient_insurance_loading()

    },[props.upload_patient_insurance_ret])

    const getDateString = (date) => {
        let ts = date.split("-")
        ts = ts[0] + "-" + ts[1].charAt(0).toUpperCase() + ts[1].charAt(1).toLowerCase() + ts[1].charAt(2).toLowerCase() + "-" + ts[2]
        return ts
    }

    const submit = async () => {
        let flag = true
        if(userDetails.mobileNumber === "") {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Mobile Number cannot be empty",
            });
            // setTabIndex('1')
        }
        else if(userDetails.name === "") {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Name cannot be empty",
            });
            // setTabIndex('1')
        }
        else if(userDetails.address === "") {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Address cannot be empty",
            });
            // setTabIndex('1')
        }
        else if(userDetails.emailId === "") {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Email cannot be empty",
            });
            // setTabIndex('1')
        }
        else if(userDetails.gender === "") {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Please select Gender",
            });
            // setTabIndex('1')
        }
        // else if(userDetails.dob === "") {
        //     flag = false
        //     notification["error"]({
        //         message: "Error",
        //         description: "Dob cannot be empty",
        //     });
        //     // setTabIndex('1')
        // }
        else if(userDetails.age === "") {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Age cannot be empty",
            });
            // setTabIndex('1')
        }
        // else if(policyDetails.ipNumber === "") {
        //     flag = false
        //     notification["error"]({
        //         message: "Error",
        //         description: "IPD number cannot be empty",
        //     });
        // }
        else if(policyDetails.insurancePartner === "") {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Please select insurance",
            });
        }
        else if(policyDetails.serviceTPA === "") {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Please select insurance company name",
            });
        }
        else if(policyDetails.policyNumner === "" && policyDetails.insurancePartner !== "Cash") {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Policy number cannot be empty",
            });
        }
        else if(userDetails.treatment === "") {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Treatment cannot be empty",
            });
        }
        // else if(policyDetails.ipNumber === "") {
        //     flag = false
        //     notification["error"]({
        //         message: "Error",
        //         description: "IP Number cannot be empty",
        //     });
        // }

        else if(policyDetails.cardNumber === "") {
            flag = false
            notification["error"]({
                message: "Error",
                description: "UHID/Member ID cannot be empty",
            });
        }

        else if(policyDetails.doa === "") {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Date of admission cannot be empty",
            });
        }

        else if(policyDetails.dod === "") {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Date of discharge cannot be empty",
            });
        }

        else if(policyDetails.costEstimation === "") {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Cost estimation cannot be empty",
            });
        }

        else if(policyDetails.costEstimation < 0) {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Cost estimation cannot be negative",
            });
        }

        else if(dayjs(policyDetails.dod).isBefore(dayjs(policyDetails.doa))) {
            flag = false
            notification["error"]({
                message: "Error",
                description:'Date of admission Cannot be after date of discharge',
            });
        }

        if(policyDetails.roomRent == "" || policyDetails.roomRent < 0 || policyDetails.roomRent == 0) {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Room rent/day cannot be empty, 0 or negative",
            });
        }      

        // else if(policyDetails.nursingCharges === "") {
        //     flag = false
        //     notification["error"]({
        //         message: "Error",
        //         description: "Nursing Charges cannot be empty",
        //     });
        // }

        else if(policyDetails.nursingCharges < 0) {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Nursing charges cannot be negative",
            });
        }
        else if(policyDetails.roomCategory === "") {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Room Category cannot be empty",
            });
        }
        else if (firstDoc.url==='') {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Please upload pre authorization request form",
            });
        }
        if(userDetails.treatment == 'Medical Management'){
            if(policyDetails.consultingDoctor === "") {
                flag = false
                notification["error"]({
                    message: "Error",
                    description: "Consulting Doctor Name cannot be empty",
                });
            }
        }
        else if(userDetails.treatment == 'Surgical Management'){
            if(policyDetails.treatingSurgeon === "") {
                flag = false
                notification["error"]({
                    message: "Error",
                    description: "Treating Surgeon's Name cannot be empty",
                });
            }
        }

        if(flag) {
            setLoading(true)
            setDisableSaveBtn(true)
            await uploadDocs()
            let finalFiles = []
            for (var i = 0; i < userDocs.length; i++) {
                finalFiles.push({
                    docType: userDocs[i].type,
                    docURL: userDocs[i].url
                })
            }
            finalFiles.push({
                docType: firstDoc.type,
                docURL: firstDoc.url
            })
            setUserDetails({
                ...userDetails,
                documents: finalFiles
            })
            let verifiedUser = await getUserDetails()
            // let reportData = await createUserReport(verifiedUser)
            createBooking(verifiedUser._id, finalFiles)
        }
    }

    const getUserDetails = async () => {
        const headers  = { 'headers': { 'Authorization': `Bearer ${Cookies.get('token_medical_auth') }`} }
        let obj =  {
            name: userDetails.name,
            mobileNumber: userDetails.mobileNumber,
            userType: "User",
            email: userDetails.emailId,
            fromPanel:true,
            gender:userDetails.gender,
            age:userDetails.age,
            address:userDetails.address,
            // documents: userDetails.documents
        }
        try {
            const userData = await Axios.post(`${get_v10_url()}/professional/validateUser`, obj, headers)
            return userData.data.data
        } catch (error) {
          notification["error"]({
            message: "Error",
            description: "An Error Occurred!! Please try again later.",
          });
          setDisableSaveBtn(false)
        //   notification["error"]({
        //     message: "Error",
        //     description: "An Error Occurred!! Please try again later.",
        //   });
        }
    }

    // const createUserReport = async (user) => {
    //     const headers  = { 'headers': { 'Authorization': `Bearer ${Cookies.get('token_medical_auth') }`} }
    //     const report = {
    //         userId: user._id,
    //         imageUrls: reportImages,
    //         reportUrls: reportPdfs,
    //         description: userDetails.treatmentDetails,
    //         additionalDetail: policyDetails.remarks,
    //         insurance: policyDetails.insurancePartner !== "Cash" ? true : false
    //     }

    //     try {
    //         const reportData = await Axios.post(`${get_v10_url()}/professional/submitReport`, report, headers)
    //         return reportData
    //     } catch (error) {
    //       notification["error"]({
    //         message: "Error",
    //         description: "An Error Occurred!! Please try again later.",
    //       });
    //       notification["error"]({
    //         message: "Error",
    //         description: "An Error Occurred!! Please try again later.",
    //       });
    //     }
    // }

    const createBooking = async (userId, files) => {
        const headers  = { 'headers': { 'Authorization': `Bearer ${Cookies.get('token_medical_auth') }`} }
        const booking = {
            date: policyDetails.doa,
            timeSlot: "9:00 AM",
            bookingStatus: "Requested",
            creditsUsed: false,
            doctorId: null,
            paymentPercent: 100,
            price: policyDetails.costEstimation,
            userId: userId,
            userAlternateNumber: userDetails.alternateNumber,
            patientAlternateNumber: userDetails.alternateNumber,
            // userReportId: reportData._id, 
            ipNumber: policyDetails.ipNumber,
            cardNumber: policyDetails.cardNumber,
            doa: policyDetails.doa,
            treatmentDetails: userDetails.treatmentDetails,
            treatment: userDetails.treatment,
            patientSex: userDetails.gender,
            patientDob: userDetails.dob,
            patientAge: userDetails.age,
            hospitalCenter: userDetails.hospitalCenter,
            remarks: policyDetails.remarks,
            dod: policyDetails.dod,
            documents: files,
            doctorName: policyDetails.consultingDoctor,
            medicalCertificateNumber: policyDetails.certificateNumber,
            doctorContactNumber: policyDetails.doctorContactNumber,
            treatingSurgeon: policyDetails.treatingSurgeon,
            bookingFrom: "HOSPITAL",
            paymentDetails: {
                roomRent: policyDetails.roomRent,
                roomCategory: policyDetails.roomCategory!=='' ? policyDetails.roomCategory : 'OTHERS',
                specifiedRoomCategory: policyDetails.specifiedRoomCategory,
                iCURent: policyDetails.iCURent,
                nursingCharges: policyDetails.nursingCharges,
                superSpecialityCharges: policyDetails.superSpecialityCharges,
                soa: policyDetails.soa,
                others: policyDetails.others,
                discount: policyDetails.discount,
                medicineConsumables: policyDetails.pharmacyCharges,
                investigation: policyDetails.investigation,
                otCharges: policyDetails.otCharges,
                anesthetist: policyDetails.anestheticFees,
                cvc: policyDetails.cvc,
                totalRoomRent: policyDetails.totalRoomRent,
            },
        }
        if(policyDetails.insurancePartner !== "Cash") {
            booking.haveInsurance = true
            booking.insuranceDetails = {
                policyNumber: policyDetails.policyNumner,
                policyType: policyDetails.policyType,
                insuranceCard: insuranceImages,
                insurancePolicy: insurancePdf,
                insurancePartner: policyDetails.insurancePartner,
                corporatePolicy: policyDetails.corporatePolicy,
                serviceTPA: policyDetails.serviceTPA,
                retailPolicy: policyDetails.retailPolicy,
            }
        }
        try {
            let bookingResult = await Axios.post(`${get_v10_url()}/professional/createManualBooking`, booking, headers)
            if(bookingResult.data.success === true) {
                notification["success"]({
                    message: 'Success',
                    description:
                        'Booking Created Successfully',
                });
                props.setActiveSideKey('1')
                setDisableSaveBtn(false)
                history.push("/dashboard/booking-details")
            }
        } catch (error) {
          notification["error"]({
            message: "Error",
            description: "An Error Occurred!! Please try again later.",
          });
          setDisableSaveBtn(false)
        }

        setLoading(false)
        
    }

    const documentOptions = [
        {
            label: "Under Writer Evidence",
            value: "UNDER WRITER EVIDENCE"
        },
        {
            label: "Authorization Letter",
            value: "AUTHORIZATION LETTER"
        },
        {
            label: "Pre Authorization Request Form",
            value: "PRE AUTHORIZATION REQUEST FORM",
            disabled: true
        },
        {
            label: "Final Hospital Bills",
            value: "FINAL HOSPITAL BILLS"
        },
        {
            label: "Investigation Records",
            value: "INVESTIGATION RECORDS"
        },
        {
            label: "Payment Receipts",
            value: "PAYMENT RECEIPTS"
        },
        {
            label: "Pharmacy or Medical Bills",
            value: "PHARMACY OR MEDICAL BILLS"
        },
        {
            label: "Indoor Case Papers",
            value: "INDOOR CASE PAPERS"
        },
        {
            label: "Implants Invoice",
            value: "IMPLANTS INVOICE"
        },
        {
            label: "Implants Label or Sticker",
            value: "IMPLANTS LABEL OR STICKER"
        },
        {
            label: "Prescription Papers",
            value: "PRESCRIPTION PAPERS"
        },
        {
            label: "Consultation Papers",
            value: "CONSULTATION PAPERS"
        },
        {
            label: "Indentity Proof - Aadhar",
            value: "INDENTITY PROOF - AADHAR"
        },
        {
            label: "Others",
            value: "OTHERS"
        },
        {
            label: "Discharge Summary",
            value: "DISCHARGE SUMMARY"
        }
    ]

    const docPropsFirst = {
        name: 'file',
        action: `${get_v10_url()}/professional/uploadBookingDoc`,
        accept: "application/pdf",
        headers: {
          authorization: `Bearer ${Cookies.get('token_medical_auth')}`,
        },
        beforeUpload: (file) => {
            const isPdf = file.type === 'application/pdf'
            const isLess5M = (file.size / 1024 / 1024) < 5
            if (!isPdf) {
                notification.error({
                    message: 'Upload Failed',
                    description: 'Please upload PDF files only'
                })
            }
            if (!isLess5M) {
                notification.error({
                    message: 'Upload Failed',
                    description: 'Please upload files with size less than 5 MB'
                })
            }
            return (isPdf && isLess5M) || Upload.LIST_IGNORE;
        },
        onChange(info) {
            if (info.file.status !== 'removed') {
                setFirstUploadFile(info.file)
            }
            if (info.file.status !== 'uploading') {
                // console.log(info.file, info.fileList);
            }
            if (info.file.status === 'done') {
                const resBooking = info.file.response.data
                setFirstDoc({
                    ...firstDoc,
                    url: resBooking.docURL,
                    file: info.file.name
                })
                notification.success({
                    message: 'Upload Succesful',
                    description: 'Document uploaded successfully'
                })
            } else if (info.file.status === 'error') {
                notification.error({
                    message: 'Upload Failed',
                    description: "Couldn't upload the document"
                })
            }
        },
        onRemove() {
            setFirstDoc({
                ...firstDoc,
                file: '',
                url: ''
            })
            // console.log(newUserDoc, "WTFF")
            setFirstUploadFile(null)
        }
    }

    const docProps = {
        name: 'file',
        action: `${get_v10_url()}/professional/uploadBookingDoc`,
        accept: "application/pdf",
        headers: {
          authorization: `Bearer ${Cookies.get('token_medical_auth')}`,
        },
        beforeUpload: (file) => {
            const isPdf = file.type === 'application/pdf'
            const isLess5M = (file.size / 1024 / 1024) < 5
            if (!isPdf) {
              notification.error({
                message: 'Error',
                description: 'Please Upload PDF files only'
              })
            }
            if (!isLess5M) {
              notification.error({
                message: 'Error',
                description: 'Please upload files with size less than 5 MB'
              })
            }
            return (isPdf && isLess5M) || Upload.LIST_IGNORE;
        },
        onChange(info) {
            if (info.file.status !== 'removed') {
                setUploadedFile(info.file)
            }
            if (info.file.status !== 'uploading') {
                // console.log(info.file, info.fileList);
            }
            if (info.file.status === 'done') {
                const resBooking = info.file.response.data
                setNewUserDoc({
                    ...newUserDoc,
                    url: resBooking.docURL,
                    file: info.file.name
                })
                Message.success(`Document uploaded successfully`);
            } else if (info.file.status === 'error') {
                Message.error(`Document upload failed.`);
            }
        },
        onRemove() {
            setNewUserDoc({
                type: null,
                file: '',
                url: ''
            })
            setUploadedFile(null)
        }
    }

    // const handleNewUserDoc = (e) => {
    //     if (typeof e === 'string') {
    //         setNewUserDoc({
    //             ...newUserDoc,
    //             type: e
    //         })
    //     } else {
    //         setNewUserDoc({
    //             ...newUserDoc,
    //             file: e.target.files[0]
    //         })
    //     }
    // }

    const handleAddNewDoc = () => {
        if (!newUserDoc.type) {
            notification["error"]({
                message: "Error",
                description: "Please select a document type for the file to be uploaded",
            })
            return
        }
        if (!newUserDoc.file) {
            notification["error"]({
                message: "Error",
                description: "Please select a file to be uploaded",
            })
            return
        }
        setUserDocs([
            ...userDocs,
            newUserDoc
        ])
        setUploadedFile(null)
        setNewUserDoc({
            type: null,
            file: '',
            url: ''
        })
    }

    const deleteUserDoc = (index) => {
        let temp = [...userDocs]
        temp.splice(index, 1)
        setUserDocs(temp)
    }

    const handleFirstPageChange = () => {
        let flag = true
        if(userDetails.mobileNumber === "") {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Mobile number cannot be empty",
            });
            return
        }
        if(userDetails.mobileNumber.length !== 10) {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Please enter 10-digits mobile number",
            });
            return
        }
        if(userDetails.alternateNumber!=="" && userDetails.alternateNumber.length !== 10) {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Please enter 10-digits alternate mobile number",
            });
            return
        }
        if(userDetails.name === "") {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Name cannot be empty",
            });
            return
        }
        if(userDetails.treatment === "") {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Treatment type cannot be empty",
            });
            return
        }
        if(userDetails.address === "") {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Address cannot be empty",
            });
            return
        }
        if(userDetails.emailId === "") {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Email cannot be empty",
            });
            return
        }
        if(userDetails.emailId !== "") {
            const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            if(!emailRegex.test(userDetails.emailId)) {
                flag = false
                notification["error"]({
                    message: "Error",
                    description: "Please enter a valid email address",
                });
                return
            }
        }
        if(userDetails.gender === "") {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Please select gender",
            });
            return
        }
        // if(userDetails.dob === "") {
        //     flag = false
        //     notification["error"]({
        //         message: "Error",
        //         description: "Dob cannot be empty",
        //     });
        //     return
        // }
        if(userDetails.age === "") {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Age cannot be empty",
            });
            return
        }
        if(userDetails.age < 0) {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Age cannot be negative",
            });
            return
        }
        if(userDetails.treatmentDetails === "") {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Procedure details cannot be empty",
            });
            return
        }

        return flag
    }

    const handleSecondPageChange = () => {
        if(handleFirstPageChange()) {
            let flag = true
            if(policyDetails.insurancePartner !== "Cash") {
                if(policyDetails.policyNumner === "") {
                    flag = false
                    notification["error"]({
                        message: "Error",
                        description: "Policy number cannot be empty",
                    });
                    return
                }
            }
            // if(policyDetails.ipNumber === "") {
            //     flag = false
            //     notification["error"]({
            //         message: "Error",
            //         description: "IPD number cannot be empty",
            //     });
            // }
            
            if(policyDetails.insurancePartner === "") {
                flag = false
                notification["error"]({
                    message: "Error",
                    description: "Please select insurance",
                });
                return
            }
            if(policyDetails.serviceTPA === "") {
                flag = false
                notification["error"]({
                    message: "Error",
                    description: "Please select insurance company name",
                });
                return
            }
            if(userDetails.treatment === "") {
                flag = false
                notification["error"]({
                    message: "Error",
                    description: "Treatment cannot be empty",
                });
                return
            }
            if(policyDetails.insurancePartner !== "Cash") {
                if(policyDetails.policyType === "") {
                    flag = false
                    notification["error"]({
                        message: "Error",
                        description: "Please select policy type",
                    });
                    return
                }
            }

            if(policyDetails.policyType === "Corporate Policy" && (policyDetails.corporatePolicy===undefined || policyDetails.corporatePolicy==="")) {
                flag = false
                notification["error"]({
                    message: "Error",
                    description: "Corporate policy name cannot be empty if policy type is corporate",
                });
                return
            }

            if(policyDetails.policyType === "Retail Policy" && (policyDetails.retailPolicy===undefined || policyDetails.retailPolicy==="")) {
                flag = false
                notification["error"]({
                    message: "Error",
                    description: "Retail name cannot be empty if policy type is retail",
                });
                return
            }
    
            if(policyDetails.doa === "") {
                flag = false
                notification["error"]({
                    message: "Error",
                    description: "Date of admission cannot be empty",
                });
                return
            }
    
            if(policyDetails.dod === "") {
                flag = false
                notification["error"]({
                    message: "Error",
                    description: "Date of discharge cannot be empty",
                });
                return
            }
    
            if(policyDetails.costEstimation === "" || policyDetails.costEstimation == 0) {
                flag = false
                notification["error"]({
                    message: "Error",
                    description: "Cost estimation cannot be empty or 0",
                });
                return
            }
    
            if(policyDetails.costEstimation < 0) {
                flag = false
                notification["error"]({
                    message: "Error",
                    description: "Cost estimation cannot be negative",
                });
                return
            }
            if(policyDetails.cardNumber === "") {
                flag = false
                notification["error"]({
                    message: "Error",
                    description: "UHID/Member ID cannot be empty",
                });
                return
            }
            if(policyDetails.roomCategory === "") {
                flag = false
                notification["error"]({
                    message: "Error",
                    description: "Room Category cannot be empty",
                });
                return
            }
            if(policyDetails.roomCategory === "OTHERS") {
                if(policyDetails.specifiedRoomCategory === "") {
                    flag = false
                    notification["error"]({
                        message: "Error",
                        description: "Please specify room category",
                    });
                    return
                }
            }
            if(policyDetails.totalRoomRent === "") {
                flag = false
                notification["error"]({
                    message: "Error",
                    description: "Total Room Rent cannot be empty",
                });
                return
            }
            if(userDetails.treatment == 'Medical Management'){
                if(policyDetails.consultingDoctor === "") {
                    flag = false
                    notification["error"]({
                        message: "Error",
                        description: "Consulting Doctor Name cannot be empty",
                    });
                    return
                }
            }
            if(userDetails.treatment == 'Surgical Management'){
                if(policyDetails.treatingSurgeon === "") {
                    flag = false
                    notification["error"]({
                        message: "Error",
                        description: "Treating Surgeon Name cannot be empty",
                    });
                    return
                }
                if(policyDetails.soa === '' || policyDetails.soa == 0 || policyDetails.soa < 0) {
                    flag = false
                    notification["error"]({
                        message: "Error",
                        description: "Surgeon Fee cannot be empty, 0 or negative",
                    });
                    return
                }
                if(policyDetails.otCharges === "" || policyDetails.otCharges == 0 || policyDetails.otCharges < 0) {
                    flag = false
                    notification["error"]({
                        message: "Error",
                        description: "OT Charges cannot be empty, 0 or negative",
                    });
                    return
                }
                if(policyDetails.anestheticFees === "" || policyDetails.anestheticFees == 0 || policyDetails.anestheticFees < 0) {
                    flag = false
                    notification["error"]({
                        message: "Error",
                        description: "Anaesthetist Fees cannot be empty, 0 or negative",
                    });
                    return
                }
            }
            
            if(policyDetails.certificateNumber === "") {
                flag = false
                notification["error"]({
                    message: "Error",
                    description: "Medical Certificate Number cannot be empty",
                });
                return
            }

            if(policyDetails.doctorContactNumber === "") {
                flag = false
                notification["error"]({
                    message: "Error",
                    description: "Doctor Contact Number cannot be empty",
                });
                return
            }
            if(policyDetails.doctorContactNumber !== "" && policyDetails.doctorContactNumber.length !== 10) {
                flag = false
                notification["error"]({
                    message: "Error",
                    description: "Enter a valid 10 digit doctor contact number",
                });
                return
            }
            if(policyDetails.cvc === "" || policyDetails.cvc == 0 || policyDetails.cvc < 0) {
                flag = false
                notification["error"]({
                    message: "Error",
                    description: "Doctor Consultation/Visit Charges cannot be empty, 0 or negative",
                });
                return
            }

            if(policyDetails.pharmacyCharges === "" || policyDetails.pharmacyCharges < 0 || policyDetails.pharmacyCharges == 0) {
                flag = false
                notification["error"]({
                    message: "Error",
                    description: "Pharmacy Charges/Consumables cannot be empty, 0 or negative",
                });
                return
            }
            if(policyDetails.discount !== "" && policyDetails.discount < 0) {
                flag = false
                notification["error"]({
                    message: "Error",
                    description: "Discount cannot be negative",
                });
                return
            }
            if(policyDetails.investigation !== "" && policyDetails.investigation < 0) {
                flag = false
                notification["error"]({
                    message: "Error",
                    description: "Investigation cannot be negative",
                });
                return
            }
            if(policyDetails.others !== "" && policyDetails.others < 0) {
                flag = false
                notification["error"]({
                    message: "Error",
                    description: "Others cannot be negative",
                });
                return
            }

            if(dayjs(policyDetails.dod).isBefore(dayjs(policyDetails.doa))) {
                flag = false
                notification["error"]({
                    message: "Error",
                    description:'Date of admission cannot be after date of discharge',
                });
                return
            }
    
            if(policyDetails.roomRent == "" || policyDetails.roomRent < 0 || policyDetails.roomRent==0) {
                flag = false
                notification["error"]({
                    message: "Error",
                    description: "Room rent/day cannot be empty, 0 or negative",
                });
                return
            }
    
            if(policyDetails.nursingCharges < 0) {
                flag = false
                notification["error"]({
                    message: "Error",
                    description: "Nursing charges cannot be negative",
                });
                return
            }
            return flag
        }
    }

    useEffect(()=>{
        if(policyDetails.doa && policyDetails.dod && policyDetails.roomRent){
            let totalRent = (dayjs(policyDetails.dod, dateFormat).diff(dayjs(policyDetails.doa, dateFormat), 'day')) * (policyDetails.roomRent)
            setPolicyDetails({...policyDetails, totalRoomRent: totalRent});
        }
        else{
            setPolicyDetails({...policyDetails, totalRooment:''});
        }

    },[policyDetails.doa, policyDetails.dod, policyDetails.roomRent])

    useEffect(()=>{
        if(userDetails.treatment === "Medical Management"){
            let total = (Number(policyDetails.totalRoomRent) || 0) + (Number(policyDetails.cvc) || 0) + (Number(policyDetails.pharmacyCharges) || 0) + (Number(policyDetails.others) || 0) + (Number(policyDetails.investigation) || 0) - (Number(policyDetails.discount) || 0);
            setPolicyDetails({...policyDetails, costEstimation: total});
        }
        if(userDetails.treatment === "Surgical Management"){
            let total = (Number(policyDetails.totalRoomRent) || 0) + (Number(policyDetails.cvc) || 0) +(Number(policyDetails.soa) || 0) +(Number(policyDetails.otCharges) || 0) + (Number(policyDetails.anestheticFees) || 0)  + (Number(policyDetails.pharmacyCharges) || 0) + (Number(policyDetails.others) || 0) + (Number(policyDetails.investigation) || 0) - (Number(policyDetails.discount) || 0);
            setPolicyDetails({...policyDetails, costEstimation: total});
        }

    },[policyDetails.totalRoomRent, policyDetails.cvc, policyDetails.pharmacyCharges, policyDetails.soa, policyDetails.otCharges, policyDetails.anestheticFees, policyDetails.others, policyDetails.investigation, policyDetails.discount]);

    return (
            <React.Fragment>
                {/* {disableSaveBtn && <GlobalLoader/>} */}
                {/* <NewNotif 
                    ret ={message}
                    retClr = {()=>set_message(false)}
                /> */}
                <Card
                    title={(
                        <div style={{display:'flex', alignItems:'center', gap:'0.75rem'}}>
                            <img src={CreateBookingIcon} alt='icon' style={{filter:'invert(61%) sepia(66%) saturate(4119%) hue-rotate(110deg) brightness(103%) contrast(105%)', height:'28px', width:'auto', marginBottom:'0.5rem'}}/>
                            <h1 style={{color:'#01D35A'}}>Submit Patient Details</h1>
                        </div>
                    )}
                    className = 'bookings-card-container'
                    headStyle={{ marginLeft: '180px', height: '64px' }}
                >
                <div className='transparent_main_content_rish'>
                    <div>
                        <div>
                            <div className="add-user-section">
                                {loading && <Space className="loading-container">
                                    <Spin size="big">
                                        <div className="content" />
                                    </Spin>
                                </Space>}
                                <div className="row">
                                    <Row gutter={24}>
                                        <div className='booking-body-heading-container'>
                                            <h1 className={`${tabIndex==='1'?'active':''}`} onClick={() => setTabIndex('1')}>User Details</h1>
                                            <h1 className={`${tabIndex==='2'?'active':''}`} onClick={() => {if(handleFirstPageChange()){setTabIndex('2')}}}>Policy Details</h1>
                                            <h1 className={`${tabIndex==='3'?'active':''}`} onClick={() => {if(handleSecondPageChange()){setTabIndex('3')}}}>Documents</h1>
                                        </div>
                                        {/* <Tabs defaultActiveKey="1" onChange={(e) => setTabIndex(e)} style={{ width: '100%' }} activeKey={tabIndex}> */}
                                            {/* <Tabs.TabPane tab={<span onClick={() => setTabIndex('1')}>User Details</span>} key={1}> */}
                                                {tabIndex==='1' && <Col className="details-box" style={{ width: '100%' }}>
                                                    {/* <h4>User Details</h4> */}
                                                    <div className="user-details-box">
                                                        <div className="container">
                                                            <Row gutter={24}>
                                                                <Col span={8}>
                                                                    <label>Patient Name*</label>
                                                                    <Input disabled={loading} value={userDetails.name} onChange={(e)=> setUserDetails({...userDetails, name:e.target.value})} className="form-input" placeholder='Enter Full Name' />
                                                                </Col>
                                                                <Col span={8}>
                                                                    <label>Mobile No*</label>
                                                                    <Input type='number' disabled={loading} value={userDetails.mobileNumber} onChange={(e)=> setUserDetails({...userDetails, mobileNumber:e.target.value})} className="form-input" placeholder='+91 0000000000'/>
                                                                </Col>
                                                                <Col span={8}>
                                                                    <label>Alternate No</label>
                                                                    <Input type='number' disabled={loading} value={userDetails.alternateNumber} onChange={(e)=> setUserDetails({...userDetails, alternateNumber:e.target.value})} className="form-input" placeholder='+91 0000000000'/>
                                                                </Col>
                                                            </Row>
                                                            {/* <Row gutter={24}>
                                                                <div style={{display:'flex'}}>
                                                                    <Map
                                                                        label = 'Location'
                                                                        className="insurance-map"
                                                                        no_save_changes = {true}
                                                                        center={{lat: 18.5204, lng: 73.8567}}
                                                                        location = {{
                                                                            coordinates:[77.026344,28.457523]
                                                                        }}
                                                                        height='120px'
                                                                        search_label = {true}
                                                                        zoom={15}
                                                                        edit_location_ret = {false}
                                                                    />
                                                                </div>
                                                            </div> */}
                                                            <Row gutter={24}>
                                                                <Col span={8}>
                                                                    <label>Patient Email Id*</label>
                                                                    <Input disabled={loading} value = {userDetails.emailId} onChange={(e)=> setUserDetails({...userDetails, emailId:e.target.value})} className="form-input" placeholder='Enter Email' />
                                                                </Col>
                                                                <Col span={8}>
                                                                    <label>DOB</label>
                                                                    <DatePicker
                                                                    className="form-input"
                                                                    value={userDetails.dob ? dayjs(userDetails.dob, dateFormat) : null}
                                                                    format={dateFormat}
                                                                    onChange={(date, dateString) => {
                                                                        if(date === null) {
                                                                            setUserDetails({
                                                                                ...userDetails,
                                                                                dob: null
                                                                            })
                                                                        }
                                                                        else if (dateString) {
                                                                                const age = dayjs().diff(dayjs(dateString), 'year');
                                                                                setUserDetails({
                                                                                    ...userDetails,
                                                                                    dob: dateString,
                                                                                    age: age
                                                                                })
                                                                        }
                                                                    }}
                                                                    placeholder='DOB'
                                                                    name='dob'
                                                                    getPopupContainer={trigger => trigger.parentElement}
                                                                    />
                                                                </Col>
                                                                <Col span={8}>
                                                                    <label>Patient Age*</label>
                                                                    <Input type="number" value = {userDetails.age} onChange={(e)=> setUserDetails({...userDetails, age:e.target.value})} className="form-input" placeholder='00 yrs' />
                                                                </Col>
                                                            </Row>
                                                            <Row gutter={24}>
                                                                {/* <Col span={8}>
                                                                    <label>Center Name</label>
                                                                    <Input disabled={loading} value = {userDetails.hospitalCenter} onChange={(e)=> setUserDetails({...userDetails, hospitalCenter:e.target.value})} className="form-input" placeholder='Enter Center Name' />
                                                                </Col> */}
                                                                <Col span={8}>
                                                                    <label>Gender*</label>
                                                                        <Select
                                                                            type="select"
                                                                            options = {[
                                                                                {
                                                                                    label:'Male',
                                                                                    value:'M'
                                                                                },
                                                                                {
                                                                                    label:'Female',
                                                                                    value:'F'
                                                                                },
                                                                                {
                                                                                    label:'Other',
                                                                                    value:'O'
                                                                                },
                                                                            ]}
                                                                            onChange={(e)=> setUserDetails({...userDetails, gender:e})}
                                                                            isMulti ={false}
                                                                            blurInputOnSelect={true}
                                                                            closeMenuOnSelect={true}
                                                                            className="booking-dropdown-container"
                                                                            suffixIcon={<CaretDownOutlined style={{color:'#30C118'}}/>}
                                                                            value = {userDetails.gender || undefined}
                                                                            placeholder='Select Gender-'
                                                                            label = "Gender"
                                                                        />
                                                                </Col>
                                                                <Col span={8}>
                                                                    <label>Treatment Type*</label>
                                                                    <Select
                                                                        type="select"
                                                                        disabled={loading}
                                                                        options = {[
                                                                            {
                                                                                label:'Medical Management',
                                                                                value:'Medical Management'
                                                                            },
                                                                            {
                                                                                label:'Surgical Management',
                                                                                value:'Surgical Management'
                                                                            },
                                                                        ]}
                                                                        onChange={(e)=> setUserDetails({...userDetails, treatment:e})}
                                                                        isMulti ={false}
                                                                        blurInputOnSelect={true}
                                                                        closeMenuOnSelect={true}
                                                                        className="booking-dropdown-container"
                                                                        suffixIcon={<CaretDownOutlined style={{color:'#30C118'}}/>}
                                                                        value = {userDetails.treatment || undefined}
                                                                        placeholder='Select Treatment Type'
                                                                        label = "Treatment-Type" 
                                                                    />
                                                                </Col>
                                                                <Col span={8}>
                                                                    <label>Patient Address*</label>
                                                                    <Input disabled={loading} value = {userDetails.address} onChange={(e)=> setUserDetails({...userDetails, address:e.target.value})} className="form-input" placeholder='Enter address' />
                                                                </Col>
                                                            </Row>
                                                            <Row gutter={24}>
                                                                <Col span={24}>
                                                                    <label>Procedure Details*</label>
                                                                    <textarea value = {userDetails.treatmentDetails} onChange={(e)=> setUserDetails({...userDetails, treatmentDetails:e.target.value})}  rows={5} className="form-input" placeholder='Enter treatment details'/>
                                                                </Col>
                                                            </Row>
                                                            <Row gutter={24} style={{ marginTop: '20px', paddingBottom:'20px' }}>
                                                                <Col span={4}>
                                                                    <Button type='primary' disabled={true} className='back-button'>
                                                                        Back
                                                                    </Button>
                                                                </Col>
                                                                <Col span={16} />
                                                                <Col span={4}>
                                                                    <Button type='primary' className='next-button' onClick={()=>{if(handleFirstPageChange()){setTabIndex('2')}}}>
                                                                        Next
                                                                    </Button>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </div>
                                                </Col>}
                                            {/* </Tabs.TabPane> */}
                                            {/* <Tabs.TabPane tab={<span onClick={() => setTabIndex('2')}>Policy Details</span>} key={2}> */}
                                                {tabIndex==='2' && <Col className="details-box" span={24}>
                                                    {/* <h4>Policy Details</h4> */}
                                                    <div className="user-details-box">
                                                        <div className="container">
                                                            <Row gutter={24} style={{marginBottom: "20px"}}>
                                                                <Col span={8}>
                                                                    <label>Insurance Partner/Cash*</label>
                                                                    {
                                                                        insuranceList && <Select
                                                                            type="select"
                                                                            disabled={loading}
                                                                            options = {insuranceList}
                                                                            onChange={(e)=> setPolicyDetails({...policyDetails, insurancePartner:e})}
                                                                            name="insurance"
                                                                            value={policyDetails.insurancePartner || undefined}
                                                                            placeholder="Choose Insurance"
                                                                            className='booking-dropdown-container'
                                                                            isMulti={true}
                                                                            blurInputOnSelect={true}
                                                                            closeMenuOnSelect={true}
                                                                            suffixIcon={<CaretDownOutlined style={{color:'#30C118'}}/>}
                                                                            showSearch
                                                                            optionFilterProp="children"
                                                                            filterOption={(input, option) => 
                                                                                (option?.name ?? '').toLowerCase().includes(input.toLowerCase())
                                                                            }
                                                                            filterSort={(opA, opB) => 
                                                                                (opA?.name ?? '').toLowerCase().localeCompare((opB?.label ?? '').toLowerCase())
                                                                            }
                                                                        />
                                                                    }
                                                                </Col>
                                                                <Col span={8}>
                                                                    <label>Insurance Company Name*</label>
                                                                    <Select
                                                                        type='select'
                                                                        options={[
                                                                            {label: "N/A", value: "NA"},
                                                                            {label: "Bajaj Allianz General Insurance Co. Ltd", value: "Bajaj Allianz General Insurance Co. Ltd"},
                                                                            {label: "Cholamandalam MS General Insurance Co. Ltd", value: "Cholamandalam MS General Insurance Co. Ltd"},
                                                                            {label: "Navi General Insurance Ltd.", value: "Navi General Insurance Ltd."},
                                                                            {label: "Future Generali India Insurance Co. Ltd.", value: "Future Generali India Insurance Co. Ltd."},
                                                                            {label: "HDFC ERGO General Insurance Co. Ltd", value: "HDFC ERGO General Insurance Co. Ltd"},
                                                                            {label: "IFFCO-TOKIO General Insurance Co. Ltd.", value: "IFFCO-TOKIO General Insurance Co. Ltd."},
                                                                            {label: "ICICI Lombard General Insurance Co. Ltd.", value: "ICICI Lombard General Insurance Co. Ltd."},
                                                                            {label: "Kotak Mahindra General insurance co. Ltd.", value: "Kotak Mahindra General insurance co. Ltd."},
                                                                            {label: "Liberty  General Insurance Co. Ltd.", value: "Liberty  General Insurance Co. Ltd."},
                                                                            {label: "Magma HDI General Insurance Co. Ltd.", value: "Magma HDI General Insurance Co. Ltd."},
                                                                            {label: "National Insurance Co. Ltd.", value: "National Insurance Co. Ltd."},
                                                                            {label: "Raheja QBE General Insurance Co. Ltd.", value: "Raheja QBE General Insurance Co. Ltd."},
                                                                            {label: "Reliance General Insurance Co. Ltd.", value: "Reliance General Insurance Co. Ltd."},
                                                                            {label: "Royal Sundaram General Insurance Co. Ltd", value: "Royal Sundaram General Insurance Co. Ltd"},
                                                                            {label: "SBI General Insurance Co. Ltd.", value: "SBI General Insurance Co. Ltd."},
                                                                            {label: "Shriram General Insurance Co. Ltd.", value: "Shriram General Insurance Co. Ltd."},
                                                                            {label: "Tata-AIG General Insurance Co. Ltd.", value: "Tata-AIG General Insurance Co. Ltd."},
                                                                            {label: "The New India Assurance Co. Ltd.", value: "The New India Assurance Co. Ltd."},
                                                                            {label: "The Oriental Insurance Co. Ltd.", value: "The Oriental Insurance Co. Ltd."},
                                                                            {label: "Universal Sompo General Insurance Co. Ltd.", value: "Universal Sompo General Insurance Co. Ltd."},
                                                                            {label: "United India Insurance Co. Ltd.", value: "United India Insurance Co. Ltd."},
                                                                            {label: "Acko General Insurance Ltd.", value: "Acko General Insurance Ltd."},
                                                                            {label: "Edelweiss General Insurance Company Limited ", value: "Edelweiss General Insurance Company Limited "},
                                                                            {label: "Go Digit General Insurance Limited", value: "Go Digit General Insurance Limited"},
                                                                            {label: "Aditya Birla Health insurance Co Ltd.", value: "Aditya Birla Health insurance Co Ltd."},
                                                                            {label: "Manipal Cigna Health Insurance Company Limited", value: "Manipal Cigna Health Insurance Company Limited"},
                                                                            {label: "Niva bupa health insurance company limited", value: "Niva bupa health insurance company limited"},
                                                                            {label: "Care Health Insurance Ltd", value: "Care Health Insurance Ltd"},
                                                                            {label: "Star Health & Allied Insurance Co. Ltd", value: "Star Health & Allied Insurance Co. Ltd"},
                                                                        ]}
                                                                        name="insurance"
                                                                        value={policyDetails.serviceTPA || undefined}
                                                                        placeholder='Choose Insurance Company'
                                                                        className="booking-dropdown-container"
                                                                        isMulti={true}
                                                                        blurInputOnSelect={true}
                                                                        closeMenuOnSelect={true}
                                                                        onChange={(e)=> {setPolicyDetails({...policyDetails, serviceTPA:e})}}
                                                                        suffixIcon={<CaretDownOutlined style={{color:'#30C118'}}/>}
                                                                        showSearch
                                                                        optionFilterProp="children"
                                                                        filterOption={(input,option)=>{
                                                                            return (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                                                        }}
                                                                        filterSort={(opA,opB) => {
                                                                            return (opA?.label ?? '').toLowerCase().localeCompare((opB?.label ?? '').toLowerCase())
                                                                        }}
                                                                        getPopupContainer={trigger => trigger.parentElement}
                                                                        listHeight={4*32}
                                                                    />
                                                                </Col>
                                                                <Col span={8}>
                                                                    <label>Type of Policy{policyDetails.insurancePartner !== "Cash" && '*'}</label>
                                                                    <Select
                                                                        type="select"
                                                                        disabled={loading || policyDetails.insurancePartner==="Cash"}
                                                                        options = {[
                                                                            {
                                                                                label: "Retail Policy",
                                                                                value: "Retail Policy",
                                                                            },
                                                                            {
                                                                                label: "Corporate Policy",
                                                                                value: "Corporate Policy",
                                                                            },
                                                                        ]}
                                                                        onChange={(e)=> setPolicyDetails({...policyDetails, policyType:e})}
                                                                        name="policyType"
                                                                        value={policyDetails.policyType || undefined}
                                                                        placeholder="Choose Policy Type"
                                                                        className='booking-dropdown-container'
                                                                        blurInputOnSelect={true}
                                                                        closeMenuOnSelect={true}
                                                                        suffixIcon={<CaretDownOutlined style={{color:'#30C118'}}/>}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                            <Row gutter={24}>
                                                                {policyDetails.policyType!=="Corporate Policy" && <Col span={8}>
                                                                    <label>Retail Name{policyDetails.policyType==='Retail Policy' && '*'}</label>
                                                                    <Input disabled={policyDetails.policyType==="Corporate Policy" || policyDetails.insurancePartner === 'Cash'} value = {policyDetails.retailPolicy} onChange={(e)=> setPolicyDetails({...policyDetails, retailPolicy:e.target.value})} className="form-input" placeholder='Enter Retail Name' />
                                                                </Col>}
                                                                {policyDetails.policyType==='Corporate Policy' && <Col span={8}>
                                                                    <label>Name of Corporate{policyDetails.policyType==='Corporate Policy' && '*'}</label>
                                                                    <Input disabled={policyDetails.policyType==="Retail Policy" || policyDetails.insurancePartner === 'Cash'} value = {policyDetails.corporatePolicy} onChange={(e)=> setPolicyDetails({...policyDetails, corporatePolicy:e.target.value})} className="form-input" placeholder='Enter Name of Corporate' />
                                                                </Col>}
                                                                <Col span={8}>
                                                                    <label>Policy No{policyDetails.insurancePartner !== "Cash" && '*'}</label>
                                                                    <Input disabled={loading || policyDetails.insurancePartner==="Cash"} value = {policyDetails.policyNumner} onChange={(e)=> setPolicyDetails({...policyDetails, policyNumner:e.target.value})} className="form-input" placeholder='Enter Policy Number' />
                                                                </Col>
                                                                <Col span={8}>
                                                                    <label>UHID/Member ID*</label>
                                                                    <Input disabled={loading} value = {policyDetails.cardNumber} onChange={(e)=> setPolicyDetails({...policyDetails, cardNumber:e.target.value})} className="form-input" placeholder='XXXX XXXX XXXX XXXX' />
                                                                </Col>
                                                            </Row>
                                                            <Row gutter={24}>
                                                                <Col span={8}>
                                                                    <label>Treatment Type</label>
                                                                    <Input disabled={true} value = {userDetails.treatment} className="form-input" placeholder={`${userDetails.treatment}`} />
                                                                </Col>
                                                                <Col span={8}>
                                                                    <label>Expected DOA (Date of Admission)*</label>
                                                                    <DatePicker 
                                                                        className="dob-date-picker"
                                                                        onChange={(date) => setPolicyDetails({...policyDetails, doa: date ? date.format(dateFormat) : null})} 
                                                                        value = {policyDetails.doa ? dayjs(policyDetails.doa, dateFormat) : null}
                                                                        format={dateFormat}
                                                                        placeholder='Select DOA'
                                                                    />
                                                                </Col>
                                                                <Col span={8}>
                                                                    <label>Date of Discharge*</label>
                                                                    <DatePicker 
                                                                        className="dob-date-picker"
                                                                        onChange={(date) => setPolicyDetails({...policyDetails, dod: date ? date.format(dateFormat) : null})}
                                                                        format={dateFormat}
                                                                        value = {policyDetails.dod ? dayjs(policyDetails.dod, dateFormat) : null}
                                                                        placeholder='Select DOD'
                                                                    />
                                                                </Col>
                                                            </Row>
                                                            <Row gutter={24}>
                                                                <Col span={8}>
                                                                    <label>Discount</label>
                                                                    <Input disabled={loading} type='number' value = {policyDetails.discount} onChange={(e)=> setPolicyDetails({...policyDetails, discount:e.target.value})} className="form-input" placeholder='₹ 00.00'/>
                                                                </Col>
                                                                <Col span={policyDetails.roomCategory=="OTHERS" ? 4 : 8}>
                                                                    <label>Room Category*</label>
                                                                    <Select
                                                                        type="select"
                                                                        options = {[
                                                                            {
                                                                                label:'General',
                                                                                value:'GENERAL'
                                                                            },
                                                                            {
                                                                                label:'Private',
                                                                                value:'PRIVATE'
                                                                            },
                                                                            {
                                                                                label:'Private AC',
                                                                                value:'PRIVATE AC'
                                                                            },
                                                                            {
                                                                                label:'Twin Categoy',
                                                                                value:'TWIN CATEGORY'
                                                                            },
                                                                            {
                                                                                label:'Deluxe',
                                                                                value:'DELUXE'
                                                                            },
                                                                            {
                                                                                label:'Super Deluxe',
                                                                                value:'SUPER DELUXE'
                                                                            },
                                                                            {
                                                                                label:'NICU',
                                                                                value:'NICU'
                                                                            },
                                                                            {
                                                                                label:'ICU',
                                                                                value:'ICU'
                                                                            },
                                                                            {
                                                                                label:'Others',
                                                                                value:'OTHERS'
                                                                            },
                                                                        ]}
                                                                        onChange={(e) => setPolicyDetails({...policyDetails, roomCategory:e})}
                                                                        isMulti ={false}
                                                                        blurInputOnSelect={true}
                                                                        closeMenuOnSelect={true}
                                                                        className="booking-dropdown-container"
                                                                        suffixIcon={<CaretDownOutlined style={{color:'#30C118'}}/>}
                                                                        value = {policyDetails.roomCategory || undefined}
                                                                        placeholder='Select Room Category'
                                                                        label = "Room Categoy" />
                                                                </Col>
                                                                {policyDetails.roomCategory=="OTHERS" && 
                                                                    <Col span={4}>
                                                                        <label>Please Specify*</label>
                                                                        <Input
                                                                            className="form-input"
                                                                            type='text'
                                                                            value={policyDetails.specifiedRoomCategory}
                                                                            onChange={(e)=> setPolicyDetails({...policyDetails, specifiedRoomCategory:e.target.value})}
                                                                            placeholder="Please Specify"
                                                                            required={policyDetails.roomCategory=="OTHERS"}
                                                                            name='specifiedRoomCategory'
                                                                        />
                                                                    </Col>
                                                                }
                                                                <Col span={8}>
                                                                    <label>Room Rent/Day*</label>
                                                                    <Input disabled={loading} value = {policyDetails.roomRent} type="number" onChange={(e)=> setPolicyDetails({...policyDetails, roomRent:e.target.value})} className="form-input" placeholder='₹ 00.00' />
                                                                </Col>
                                                            </Row>
                                                            <Row gutter={24}>
                                                                <Col span={8}>
                                                                    <label>Total Room Rent*</label>
                                                                    <Input disabled={true} type="number" value = {policyDetails.totalRoomRent}  className="form-input" placeholder={'Enter DOA, DOD and Room Rent/Day First'}/>
                                                                </Col>
                                                                { userDetails.treatment =="Medical Management" ? (
                                                                    <Col span={8}>
                                                                        <label>Consulting Doctor Name*</label>
                                                                        <Input disabled={loading} value = {policyDetails.consultingDoctor} onChange={(e)=> setPolicyDetails({...policyDetails, consultingDoctor:e.target.value})} className="form-input" placeholder='Enter Consulting Doctor Name' />
                                                                    </Col>
                                                                ) : userDetails.treatment == 'Surgical Management' ? (
                                                                    <Col span={8}>
                                                                        <label>Treating Surgeon's Name*</label>
                                                                        <Input disabled={loading} value = {policyDetails.treatingSurgeon} onChange={(e)=> setPolicyDetails({...policyDetails, treatingSurgeon:e.target.value})} className="form-input" placeholder="Enter Treating Surgeon's Name" />
                                                                    </Col> 
                                                                ) : (<></>)}
                                                                <Col span={8}>
                                                                    <label>Medical Certificate Number*</label>
                                                                    <Input disabled={loading} value = {policyDetails.certificateNumber} onChange={(e)=> setPolicyDetails({...policyDetails, certificateNumber:e.target.value})} className="form-input" placeholder='Enter Medical Certificate Number' />
                                                                </Col>
                                                            </Row>
                                                            <Row gutter={24}>
                                                                <Col span={8}>
                                                                    <label>Doctor Contact Number*</label>
                                                                    <Input type='number' disabled={loading} value = {policyDetails.doctorContactNumber} onChange={(e)=> setPolicyDetails({...policyDetails, doctorContactNumber:e.target.value})} className="form-input" placeholder='Enter Doctor Contact Number' />
                                                                </Col>
                                                                { userDetails.treatment =="Medical Management" ? (
                                                                    <>
                                                                        <Col span={8}>
                                                                            <label>Pharmacy Charges/ Consumables*</label>
                                                                            <Input disabled={loading} value = {policyDetails.pharmacyCharges} type="number" onChange={(e)=> setPolicyDetails({...policyDetails, pharmacyCharges:e.target.value})} className="form-input"placeholder='₹ 00.00' />
                                                                        </Col>
                                                                        <Col span={8}>
                                                                            <label>Investigation Charges (If Any)</label>
                                                                            <Input type='number' disabled={loading} value = {policyDetails.investigation} onChange={(e)=> setPolicyDetails({...policyDetails, investigation:e.target.value})} className="form-input" placeholder='Enter investigation (If any)' />
                                                                        </Col>
                                                                    </>
                                                                    
                                                                ) : userDetails.treatment == 'Surgical Management' ? (
                                                                   <>
                                                                    <Col span={8}>
                                                                        <label>Surgeon Fee*</label>
                                                                        <Input disabled={loading} value = {policyDetails.soa} type="number" onChange={(e)=> setPolicyDetails({...policyDetails, soa:e.target.value})} className="form-input" placeholder='₹ 00.00' />
                                                                    </Col>
                                                                    <Col span={8}>
                                                                        <label>OT Charges*</label>
                                                                        <Input disabled={loading} value = {policyDetails.otCharges} type="number" onChange={(e)=> setPolicyDetails({...policyDetails, otCharges:e.target.value})} className="form-input" placeholder='₹ 00.00' />
                                                                    </Col>
                                                                   </>
                                                                ) : (<></>)}
                                                            </Row>
                                                            {userDetails.treatment == 'Surgical Management' && (
                                                                <Row gutter={24}>
                                                                    <Col span={8}>
                                                                    <label>Anaesthetist Fees*</label>
                                                                    <Input disabled={loading} value = {policyDetails.anestheticFees} type="number" onChange={(e)=> setPolicyDetails({...policyDetails, anestheticFees:e.target.value})} className="form-input" placeholder='₹ 00.00' />

                                                                    </Col>
                                                                    <Col span={8}>
                                                                        <label>Pharmacy Charges/ Consumables*</label>
                                                                        <Input disabled={loading} value = {policyDetails.pharmacyCharges} type="number" onChange={(e)=> setPolicyDetails({...policyDetails, pharmacyCharges:e.target.value})} className="form-input" placeholder='₹ 00.00' />
                                                                    </Col>
                                                                    <Col span={8}>
                                                                        <label>Investigation (If Any)</label>
                                                                        <Input disabled={loading} value = {policyDetails.investigation} type="number" onChange={(e)=> setPolicyDetails({...policyDetails, investigation:e.target.value})} className="form-input" placeholder='₹ 00.00' />
                                                                    </Col>
                                                                </Row>
                                                            )}
                                                            <Row gutter={24}>
                                                                <Col span={8}>
                                                                    <label>Doctor Consultation/Visit Charges*</label>
                                                                    <Input disabled={loading} value = {policyDetails.cvc} type="number" onChange={(e)=> setPolicyDetails({...policyDetails, cvc:e.target.value})} className="form-input" placeholder='₹ 00.00' />
                                                                </Col>
                                                                <Col span={8}>
                                                                    <label>Others</label>
                                                                    <Input disabled={loading} value = {policyDetails.others} type="number" onChange={(e)=> setPolicyDetails({...policyDetails, others:e.target.value})} className="form-input" placeholder='Others' />
                                                                </Col>
                                                                <Col span={8}>
                                                                    <label>Total Cost Estimation (₹)*</label>
                                                                    <Input disabled={true} type='number' value = {policyDetails.costEstimation}  className="form-input" placeholder= {policyDetails.costEstimation}/>
                                                                </Col>
                                                            </Row>
                                                            <Row gutter={24} style={{ marginTop: '60px', }}>
                                                                <Col span={4}>
                                                                    <Button type='primary' className='back-button' onClick={() => { setTabIndex('1')}}>
                                                                        Back
                                                                    </Button>
                                                                </Col>
                                                                <Col span={16} />
                                                                <Col span={4}>
                                                                    <Button type='primary' className='next-button' onClick={() => {if(handleSecondPageChange()){setTabIndex('3')}}}>
                                                                        Next
                                                                    </Button>
                                                                </Col>
                                                            </Row>
                                                            {/* <Row gutter={24}>
                                                                <Col span={24}>
                                                                    <label>Treatment Details</label>
                                                                    <textarea onChange={(e)=> setPolicyDetails({...policyDetails, remarks:e.target.value})} rows={5} className="form-input" />
                                                                </Col>
                                                            </Row> */}
                                                        </div>
                                                    </div>
                                                </Col>}
                                                {/* <div className="submit-btn">
                                                    <Button disabled={loading} onClick={(e) => {
                                                        e.preventDefault()
                                                        submit()
                                                    }}>Submit</Button>
                                                </div> */}
                                            {/* </Tabs.TabPane> */}
                                            {tabIndex==='3' && (
                                                <Col span={24} className='details-box'>
                                                    <div className='user-details-box'>
                                                        <div className='container'>
                                                        <div className="row upload-docs-container">
                                                                <Col span={24}>
                                                                    <label className="upload-docs-link">Attach Pre Authorization Request Form*</label>
                                                                    <Row gutter={24} style={{ marginTop: '10px' }}>
                                                                        <Row style={{ width: '100%', alignItems: 'center' }}>
                                                                            <Col span={12} style={{ paddingRight: '20px' }}>
                                                                                {/* <label>Document Type</label> */}
                                                                                <Select
                                                                                    type="select"
                                                                                    disabled={true}
                                                                                    options={documentOptions}
                                                                                    isMulti={false}
                                                                                    blurInputOnSelect={true}
                                                                                    closeMenuOnSelect={true}
                                                                                    className="booking-dropdown-container"
                                                                                    label="Document Type"
                                                                                    value={firstDoc.type || undefined}
                                                                                    suffixIcon={<CaretDownOutlined style={{color:'#30C118'}}/>}
                                                                                    placeholder='Choose Document Type'
                                                                                />
                                                                            </Col>
                                                                            <Col span={6}>
                                                                                <Upload { ...docPropsFirst } id='userDocUpload__id' fileList={firstUploadFile ? [firstUploadFile] : []} className='booking-upload-docs-container'>
                                                                                    <Button icon={<UploadOutlined />} className='booking-upload-docs-btn'>Upload Doc</Button>
                                                                                </Upload>
                                                                            </Col>
                                                                        </Row>
                                                                    </Row>
                                                                </Col>
                                                            </div>
                                                            <div className="row upload-docs-container">
                                                                <Col span={24}>
                                                                    <label className="upload-docs-link">Attach Reports and Prescriptions</label>
                                                                    <Row gutter={24} style={{ marginTop: '10px' }}>
                                                                            {/* <Col span={12}>
                                                                                <label>Upload Images</label>
                                                                                <input disabled={loading} type="file" accept="image/png, image/gif, image/jpeg" multiple onChange={(e) => uploadReportImages(e)}  placeholder="Click To Upload" />
                                                                            </Col>
                                                                            <Col span={12}>
                                                                                <label>Upload Pdfs</label>
                                                                                <input disabled={loading} type="file" accept="application/pdf" multiple onChange={(e) => uploadDocs(e)} placeholder="Click To Upload" />
                                                                            </Col> */}
                                                                        {
                                                                            userDocs.map((doc, index) => (
                                                                                <Row key={index} style={{ width: '100%', alignItems: 'center', marginBottom: '16px' }}>
                                                                                    <Col span={12} style={{ paddingRight: '20px' }}>
                                                                                        <Select
                                                                                            disabled={true}
                                                                                            type="select"
                                                                                            value={doc.type}
                                                                                            style={{ width: '100%' }}
                                                                                            className='booking-uploaded-doc-type'
                                                                                        />
                                                                                    </Col>
                                                                                    <Col span={6}>
                                                                                        <Input
                                                                                            disabled={true}
                                                                                            type="text"
                                                                                            value={doc.file}
                                                                                            style={{ marginTop: '0px' }}
                                                                                            className='form-input-upload'
                                                                                        />
                                                                                    </Col>
                                                                                    <Col span={6} style={{ paddingLeft: '20px', display:'flex', alignItems:'center', justifyContent:'center' }}>
                                                                                        <Button type='link' onClick={() => deleteUserDoc(index)} className='remove-link-upload'>Remove</Button>
                                                                                    </Col>
                                                                                </Row>
                                                                            ))
                                                                        }
                                                                        <Row style={{ width: '100%', alignItems: 'center' }}>
                                                                            <Col span={12} style={{ paddingRight: '20px' }}>
                                                                                {/* <label>Document Type</label> */}
                                                                                <Select
                                                                                    type="select"
                                                                                    options={documentOptions}
                                                                                    isMulti={false}
                                                                                    blurInputOnSelect={true}
                                                                                    closeMenuOnSelect={true}
                                                                                    className="booking-dropdown-container"
                                                                                    label="Document Type"
                                                                                    value={newUserDoc.type || undefined}
                                                                                    onChange={(e) => setNewUserDoc({ ...newUserDoc, type: e })}
                                                                                    suffixIcon={<CaretDownOutlined style={{color:'#30C118'}}/>}
                                                                                    placeholder='Choose Document Type'
                                                                                />
                                                                            </Col>
                                                                            <Col span={6}>
                                                                                {/* <label>Upload Document</label> */}
                                                                                {/* <input
                                                                                    id='userDocUpload__id'
                                                                                    disabled={loading}
                                                                                    type="file"
                                                                                    accept='application/pdf'
                                                                                    multiple={false}
                                                                                    onChange={(e) => handleNewUserDoc(e)}
                                                                                /> */}
                                                                                <Upload { ...docProps } id='userDocUpload__id' fileList={uploadedFile ? [uploadedFile] : []} className='booking-upload-docs-container'>
                                                                                    <Button icon={<UploadOutlined />} className='booking-upload-docs-btn'>Upload Doc</Button>
                                                                                </Upload>
                                                                            </Col>
                                                                            <Col span={6} style={{paddingLeft:'24px'}}>
                                                                                <Button onClick={handleAddNewDoc} className='booking-add-new-doc-btn'>Add</Button>
                                                                            </Col>
                                                                        </Row>
                                                                    </Row>
                                                                    <Row gutter={24} style={{ marginTop: '60px', }}>
                                                                        <Col span={4}>
                                                                            <Button type='primary' className='back-button' onClick={() => { setTabIndex('2')}}>
                                                                                Back
                                                                            </Button>
                                                                        </Col>
                                                                        <Col span={16} />
                                                                        <Col span={4}>
                                                                            <Button disabled={loading || disableSaveBtn} type='primary' className='next-button' onClick={(e) => {
                                                                                e.preventDefault()
                                                                                submit()
                                                                            }}>
                                                                                Submit
                                                                            </Button>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            )}
                                        {/* </Tabs> */}
                                    </Row>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </Card>
            </React.Fragment>
    )
}


const mapStateToProps = state => ({
    user: state.authStore.user
})

    
export default connect(mapStateToProps)(CreateBooking);
